// extracted by mini-css-extract-plugin
module.exports = {"label":"_8c559fa4c7--label--hIfaq","cursor_pointer":"_8c559fa4c7--cursor_pointer--Pe1mY"};